<template>
<div class="mb-7">

  <v-app-bar
        color="blueDark"
        dense
        fixed
        dark>

            <v-app-bar-nav-icon
                class="blueLigth--text"
                @click.stop="drawer = !drawer">
            </v-app-bar-nav-icon>
            <v-img 
                class="mr-3"
                max-width="100"
                :src="logo"
                ></v-img> 

            <v-spacer></v-spacer>
            <!-- <div class="mr&#45;3">{{ activepage }}</div> -->
            <span class="mr-1">
                {{ totalInfo.factP }} 
            </span>
            <span
                v-show="totalInfo.factP"
                class="orangeMain--text"> 
                / {{ totalInfo.prognosisP }}%
            </span>
            <v-toolbar-title
                class="px-2 blueLigth--text" >
                    ₽
            </v-toolbar-title>

            <span class="mr-1">
                {{ totalInfo.factM | moneyM }}
            </span>
            <span class="orangeMain--text">
                / {{ totalInfo.planM | moneyM }}
                </span>
    </v-app-bar>


<!-- Navigation drawer -->
    <v-navigation-drawer
        app temporary
        v-model="drawer"
        class="orangeDark"
        >
        <v-img 
            class="mx-4 mt-4 mb-3"
            :src="logoWhite"></v-img>
        <v-list>
            <v-list-item
              @click="$router.push({path: '/shoplist'}); drawer = false"
                :disabled="$route.path=='/shoplist'">
                <v-list-item-icon>
                    <v-icon>store</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title>Магазины</v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-list-item
              @click="$router.push({path: '/sellerlist'}); drawer = false"
                :disabled="$route.path=='/sellerlist'">
                <v-list-item-icon>
                    <v-icon>people</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title>Сотрудники</v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-list-item
              @click="$router.push({path: '/bonus'}); drawer = false"
                :disabled="$route.path=='/bonus'">
                <v-list-item-icon>
                    <v-icon>monetization_on</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title>Экстра бонусы</v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-list-item
               @click="$router.push({path: '/top'}); drawer = false"
                :disabled="$route.path=='/top'"
                link>
                <v-list-item-icon>
                    <v-icon>emoji_events</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title>Рейтинги</v-list-item-title>
                </v-list-item-content>
            </v-list-item>

           <!--  <v-list-item
              @click="$router.push({path: '/goods'}); drawer = false"
                :disabled="$route.path=='/goods'">
                <v-list-item-icon>
                    <v-icon>radio_button_checked</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title>Товар</v-list-item-title>
                </v-list-item-content>
            </v-list-item> -->

            <v-list-item
              @click="$router.push({path: '/analysis'}); drawer = false"
                :disabled="$route.path=='/analysis'">
                <v-list-item-icon>
                    <v-icon>radio_button_checked</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title>Анализ</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </v-list>
        <v-row
            @click.stop="drawer = !drawer"
            justify="center"
            >
            <v-date-picker
                reactive
                light
                color="orangeDark"
                header-color="orangeDark"
                v-model="date"
                type="month"
                year-icon="mdi-calendar-blank"
                prev-icon="mdi-skip-previous"
                next-icon="mdi-skip-next"
                locale="ru"
            ></v-date-picker>
        </v-row>
        <v-list>
            <v-list-item v-if="~domen.indexOf('tapeti')"
                @change="drawer = false"
                link
                target="_blank"
                href="https://docs.google.com/forms/d/e/1FAIpQLSeDTzxUjfiTth0L-E10d8Tll5qhJihZoC-G3r3Jx0nkkTudNA/viewform"
                >
                <v-list-item-icon>
                    <v-icon>check_circle_outline</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title>Проверка магазина</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="~domen.indexOf('tapeti')"
                @change="drawer = false"
                link
                target="_blank"
                href="https://docs.google.com/spreadsheets/d/1QQv9EkLedmhluVVnOniH2JBFXJ4x7ZfENhCy2pZ82Hg/edit?usp=sharing"
                >
                <v-list-item-icon>
                    <v-icon>playlist_add_check</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title>Результаты проверок</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item
              @click="logout(); drawer = false"
                :disabled="$route.path=='/logout'">
                <v-list-item-icon>
                    <v-icon>exit_to_app</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title>Выход</v-list-item-title>
                    <span class="font-weight-thin">{{username}}</span>
                </v-list-item-content>
            </v-list-item>
        </v-list>
    </v-navigation-drawer>
  
</div>
</template>

<script>
import {mapState, mapMutations} from 'vuex';
export default {
name: 'Header',
data () {
  return {
    date: new Date().toISOString().substr(0, 7),
    drawer: false,
  }
},

computed: {
  ...mapState(['logo', 'logoWhite', 'totalInfo', 'username', 'domen']),

},

methods: {
  ...mapMutations(['set_aver', 'set_date', 'set_total_info', 'set_shop_info']),

  logout() { //выход из системы
    this.set_total_info({});
    this.set_shop_info({});
    this.set_aver({});
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    this.$router.push({name: 'Login'});
  }

},

watch: {

  date () {
    this.set_date(this.date);
    this.$store.dispatch('init_total_info');
  },


},


}

</script>
